import React, {memo} from 'react';
import { useIntl } from 'react-intl';

import Block from '../block';
import SimpleTeaser from '../simple-teaser';
import IntlStringHtml from '../intl-string-html';
import IntlString, { intlString } from '../intl-string';

const TeaserLight = memo(
	/**
	 * @param {{
	 *   headline: null | undefined | import('../../../tmp/graphql-types').IntlStringFragment,
	 *   text: null | undefined | import('../../../tmp/graphql-types').IntlStringHtmlFragment,
	 *   url: null | undefined | string,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function TeaserLight({headline, url, text}) {
		const intl = useIntl();

		const anchor = headline && intlString(intl, headline);

		return (
			<Block padding={true}>
				<SimpleTeaser
					anchor={anchor || undefined}
					headline={headline && (
						<IntlString handleLines={true} {...headline} />
					)}
					url={url || undefined}
				>
					{text && (
						<IntlStringHtml {...text} />
					)}
				</SimpleTeaser>
			</Block>
		);
	}
);

export default TeaserLight;
